export const classes = {
  imgWrapper:
    'size-12 place-center bg-white dark:bg-[#332e43] rounded-xl shadow-card',
  img: 'rounded-lg max-w-full max-h-full bg-white dark:bg-[#332e43]',
};
